import { Map as FullwidthMap, type IMapCoordinates } from '@cian/frontend-newbuilding-map-component';
import {
  type TCustomBalloonFetchHtmlFunction,
  type TGeoObjectsFetchFunction,
} from '@cian/frontend-newbuilding-map-component/es/types';

import { type FC } from 'react';

import styles from './Map.css';

interface IMapProps {
  apiKey: string;
  onGeoObjectsFirstFetch: TGeoObjectsFetchFunction;
  onCustomBalloonHtmlFetch: TCustomBalloonFetchHtmlFunction;
  pinCoordinates: IMapCoordinates;
  zoom: number;
  currentTypes: string[];
}

export const Map: FC<IMapProps> = props => {
  const { apiKey, onCustomBalloonHtmlFetch, onGeoObjectsFirstFetch, pinCoordinates, zoom, currentTypes } = props;

  return (
    <section className={styles['map']} data-testid="pik-projects-map">
      <FullwidthMap
        firstPaintOptions={{
          apiKey,
          controls: [{ type: 'ZoomControl' }, { type: 'GeolocationControl' }, { type: 'FullscreenControl' }],
          fetch: {
            onCustomBalloonHtmlFetch,
            onGeoObjectsFetch: onGeoObjectsFirstFetch,
          },
          id: 'pik-map',
          styles: { height: '100%', width: '100%' },
        }}
        geoObjectNames={currentTypes}
        media={[
          {
            maxWidth: Infinity,
            minWidth: -Infinity,
            options: {
              animationDuration: 300,
              center: pinCoordinates,
              defaultZoom: zoom,
              styles: { height: '100%', width: '100%' },
            },
          },
        ]}
      />
    </section>
  );
};
